module.exports = __webpack_public_path__ + "img/autotitle.dedf3ab4.png";